import { render, staticRenderFns } from "./couponAdditionalInfo.vue?vue&type=template&id=02e64ca4"
import script from "./couponAdditionalInfo.vue?vue&type=script&lang=js"
export * from "./couponAdditionalInfo.vue?vue&type=script&lang=js"
import style0 from "./couponAdditionalInfo.vue?vue&type=style&index=0&id=02e64ca4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports